
import { defineComponent, reactive, watch } from 'vue';
import Icone from '@/core/components/Icone.vue';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { ITelaOperacao } from '@/core/models/ITelaOperacao';
import { ETipoPermissao } from '@/models/Enumeradores/MeuSistema/Usuarios/ETipoPermissao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import SelecionarEmpresa from '@/components/MeuSistema/Empresas/SelecionarEmpresa.vue';
import ServicoVeiculoMarcaModelo from '@/servicos/Cadastros/Veiculo/ServicoVeiculoMarcaModelo';
import { IVeiculoMarcaModelo } from '@/models/Entidades/Cadastros/Veiculos/IVeiculoMarcaModelo';
import SelecionarMarca from '@/components/Cadastros/Produtos/SelecionarMarca.vue';
import SelecionarTipoVeiculo from '@/components/Cadastros/Veiculos/SelecionarTipoVeiculo.vue';
import SelecionarEspecieVeiculo from '@/components/Cadastros/Veiculos/SelecionarEspecieVeiculo.vue';

export default defineComponent({
  name: 'VeiculoMarcaModeloModal',
  props: {
    visivel: {
      type: Boolean,
    },
    operacao: {
      type: Object as () => ITelaOperacao,
      required: true,
    },
  },
  components: {
    Icone,
    RequisicaoModal,
    SelecionarEmpresa,
    SelecionarMarca,
    SelecionarTipoVeiculo,
    SelecionarEspecieVeiculo,
  },
  emits: ['sincronizarRegistro', 'update:operacao', 'update:visivel'],
  setup(props, { emit }) {
    const {
      telaBase, obterPermissoes, preencherPermissoesDados, preencherEmpresasComEstrategiaPermissaoDados,
      apresentarMensagemSucesso, defineEmpresasSelecionadasCadastroCompartilhado,
      filtrarPermissaoDadosUsuarioMultiEmpresas, verificaConceitoParaApresentarEmpresas,
    } = useTelaBase();

    const {
      modalBase, apresentarRetornoRequisicao, apresentarBarraProgresso, ocultarBarraProgresso,
      defineNovaOperacao, defineTextoPadraoBotoes, sincronizarRegistro,
    } = useModalBase(props, emit);

    const servicoVeiculoMarcaModelo = new ServicoVeiculoMarcaModelo();
    telaBase.identificadorRecurso = 'CADASTRO_VEICULO_MARCA_MODELO';
    telaBase.identificadorPermissao = 'PER_CADASTRO_VEICULO_MARCA_MODELO';

    const state = reactive({
      marcaModelo: {} as IVeiculoMarcaModelo,
    });

    function objetoInicial() {
      state.marcaModelo = {} as IVeiculoMarcaModelo;
      state.marcaModelo.codigo = 0;
      state.marcaModelo.ativo = true;
      state.marcaModelo.tipoVeiculo = '06';
      state.marcaModelo.especieVeiculo = 1;
      telaBase.empresasSelecionadas = [];
    }

    async function salvar(salvarNovo: boolean) {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
      apresentarBarraProgresso();

      state.marcaModelo.codigoEmpresa = telaBase.empresasSelecionadas?.[0] ?? props.operacao.empresaSelecionada;
      console.log('state.marcamodelo: ', state.marcaModelo);
      if (props.operacao.tipoPermissaoDados === EPermissaoDados.Incluir) retorno = await servicoVeiculoMarcaModelo.incluir(state.marcaModelo);
      else if (props.operacao.tipoPermissaoDados === EPermissaoDados.Visualizar) retorno = await servicoVeiculoMarcaModelo.alterar(state.marcaModelo);

      ocultarBarraProgresso();

      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        sincronizarRegistro(props.operacao.tipoPermissaoDados === EPermissaoDados.Incluir ? EPermissaoDados.Incluir : EPermissaoDados.Alterar,
          props.operacao.tipoPermissaoDados === EPermissaoDados.Incluir ? retorno.codigoRegistro : props.operacao.codigoRegistro);
        apresentarMensagemSucesso(retorno.mensagem);

        if (salvarNovo) {
          objetoInicial();
          telaBase.empresasSelecionadas = [props.operacao.empresaSelecionada];
          defineNovaOperacao(props.operacao);
        } else modalBase.computedVisivel = false;
      } else apresentarRetornoRequisicao(retorno);
    }

    watch(async () => modalBase.computedVisivel, async () => {
      telaBase.carregando = true;
      objetoInicial();

      if (modalBase.computedVisivel) {
        if (props.operacao.listaPermissoesDados.length > 0) await preencherPermissoesDados(props.operacao.listaPermissoesDados);
        else await obterPermissoes(ETipoPermissao.Dados);

        await preencherEmpresasComEstrategiaPermissaoDados(props.operacao.tipoPermissaoDados, true);
        defineTextoPadraoBotoes(props.operacao.tipoPermissaoDados);

        if (props.operacao.tipoPermissaoDados === EPermissaoDados.Visualizar) {
          state.marcaModelo = await servicoVeiculoMarcaModelo.obter(props.operacao.codigoRegistro, props.operacao.empresaSelecionada);
          telaBase.empresasSelecionadas = state.marcaModelo.codigoEmpresa ? [state.marcaModelo.codigoEmpresa] : [props.operacao.empresaSelecionada];
        } else {
          await defineEmpresasSelecionadasCadastroCompartilhado(props.operacao.empresaSelecionada);
        }

        telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
        verificaConceitoParaApresentarEmpresas();
      }

      telaBase.carregando = false;
    });

    return {
      telaBase, props, modalBase, state, salvar, objetoInicial, EPermissaoDados,
    };
  },
});
